// extracted by mini-css-extract-plugin
export default {"container":"ViewHeader_container__bz9AF","entityId":"ViewHeader_entityId__VEeJ7","badgesAndActions":"ViewHeader_badgesAndActions__hzlxs"};